<template>
    <div
        class="pointer-events-none flex -translate-x-[50%]"
        :class="{
            '-translate-y-[100%] flex-col': position === 'top',
            'flex-col-reverse': position === 'bottom',
        }"
    >
        <div
            class="whitespace-nowrap rounded-md bg-grind-800 px-3.5 py-2.5 text-sm leading-none text-white"
        >
            <slot />
        </div>

        <div
            class="mx-auto w-0 border-[10px] border-grind-800 border-l-transparent border-r-transparent"
            :class="{
                '-mb-[9px] border-b-transparent': position === 'top',
                '-mt-[9px] border-t-transparent': position === 'bottom',
            }"
        ></div>
    </div>
</template>

<script lang="ts" setup>
withDefaults(
    defineProps<{
        position?: 'top' | 'bottom';
    }>(),
    {
        position: 'top',
    },
);
</script>
